
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/Common/VSelect.vue";
import UserMixin, { UserTags } from "@/mixins/http/UserMixin";
import { safeAsync } from "@/utils/AsyncUtil";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { httpStore } from "@/store/typed";
import Throttler from "@/utils/Throttler";
import { User } from "@/models";

@Component({ components: { VSelect } })
export default class UserSelect extends Mixins(UserMixin) {
  @RegisterHttp(UserTags.UserIndex)
  readonly getRequest!: RequestData;

  @Prop({ required: false })
  readonly selected!: any | null;

  @Prop()
  readonly queryKey?: string;

  @Prop()
  readonly label?: string;

  @Prop({ default: "Seleziona un utente" })
  readonly placeholder?: string;

  @Prop({ default: false })
  readonly preselect!: boolean;

  @Prop({ default: false })
  readonly actsAsFilter!: boolean;

  @Prop()
  readonly filter!: any;

  options: VSelectOption[] = [];

  private value: any | null = this.selected || null;

  private items: User[] = [];
  private term: string | null = null;
  private throttler: Throttler = new Throttler();

  mounted() {
    this.loadItems();
  }

  onSearched(term: string) {
    this.throttler.run(() => {
      this.term = term;
      this.loadItems();
    });
  }

  @Watch("selected")
  onSelectedChanged(selected: string) {
    this.value = selected;
    this.onItemsReady();
  }

  get payload() {
    let data: any = {
      page: {
        size: 100,
      },
    };

    if (this.filter) {
      data.filter = this.filter;
      if (this.term) {
        data.filter.term = this.term;
      }
    } else {
      data.filter = { term: this.term };
    }

    return data;
  }

  get filterDefault() {
    return { id: "all", text: "Tutto" };
  }

  get loading() {
    return httpStore.status[this.tag]?.loading;
  }

  get tag() {
    return UserTags.UserIndex;
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);
    this.$emit(
      "inputRaw",
      this.items.find((o: User) => o.id === id)
    );

    if (this.queryKey && this.$route.query[this.queryKey] !== this.value) {
      let query = this.$route.query;
      query[this.queryKey] = this.value;

      this.$router.push({ query });
    }
  }

  onItemsReady() {
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find(
        (o) => o.id === this.selected.toString()
      )?.id;
    }
  }

  async loadItems() {
    if (this.actsAsFilter) {
      this.options.unshift(this.filterDefault);
    }
    const [data, error] = await safeAsync(this.getUsers(this.payload));

    if (data) {
      this.items = data;
      this.options = this.items.map((o: User) => {
        return { id: o.id, text: `${o.firstName} ${o.lastName}` };
      });
      this.onItemsReady();
    } else {
      console.log(error);
    }
  }
}
